import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';

import messages from '../../../locale/jsonMessages';
import { photosShow } from '../../../helpers/photosShow';
import { fileuploadDir, profilePhotouploadDir, dateFormat } from '../../../config';
import { formatLocalizedDate } from '../../../helpers/formatLocateDate';
import { formatTime } from '../../../helpers/formatting';
import { getDynamicTitle } from '../../../helpers/GetDynamicItemName/getDynamicName';
import { toDayNumber } from '../../../helpers/inspectionPresentation';
import s from '../Inspection.css';

const photoName = (listData) => {
  const photos = (listData && listData.listPhotos) || [];
  if (!photos.length) return null;
  const cover = photos.find((photo) => photo.id === listData.coverPhoto);
  return (cover || photos[0]).name;
};

// Reminder of the reservation at the top of every check-in / check-out screen (R1): vehicle, departure place, period, renter, owner.
export function ReservationSummaryCard({ reservation, dynamicTitle, intl }) {
  const { formatMessage, locale } = intl;
  if (!reservation) return null;
  const { listData, hostData, guestData } = reservation;
  const name = photoName(listData);
  const photo = name ? `${photosShow(fileuploadDir)}x_medium_${name}` : null;
  let title = reservation.listTitle || (listData && listData.title) || '';
  if (reservation.dynamicListTitle) {
    try {
      const translated = getDynamicTitle({ data: JSON.parse(reservation.dynamicListTitle), locale, id: reservation.listId });
      if (translated) title = translated;
    } catch (error) { /* keep the plain title */ }
  } else if (dynamicTitle) {
    const translated = getDynamicTitle({ data: dynamicTitle, locale, id: reservation.listId });
    if (translated) title = translated;
  }
  const place = listData ? [listData.street, listData.city, listData.country].filter(Boolean).join(', ') : '';
  const fmt = (value) => (value ? formatLocalizedDate(Number.isNaN(Number(value)) ? value : Number(value), locale, dateFormat && dateFormat.displayDateFormat) : '');
  const days = (() => {
    const start = toDayNumber(reservation.checkIn);
    const end = toDayNumber(reservation.checkOut);
    return start !== null && end !== null ? Math.max(1, end - start + 1) : null;
  })();
  return (
    <section className={s.card} aria-label={formatMessage(messages.inspSummaryTitle)}>
      <div className={s.summary}>
        <div className={s.summaryVehicle}>
          {photo && <img className={s.summaryPhoto} src={photo} alt="" />}
          <div>
            <p className={s.summaryName}>{title}</p>
            {listData && listData.transmission && <p className={s.summaryMuted}>{listData.transmission}</p>}
          </div>
        </div>
        <div>
          <p className={s.summaryLabel}>{formatMessage(messages.inspSummaryPlace)}</p>
          <p className={s.summaryValue}>{place || '-'}</p>
        </div>
        <div>
          <p className={s.summaryLabel}>{formatMessage(messages.inspSummaryPeriod)}</p>
          <p className={s.summaryValue}>{fmt(reservation.checkIn)} {formatTime(reservation.startTime)}</p>
          <p className={s.summaryValue}>{'→'} {fmt(reservation.checkOut)} {formatTime(reservation.endTime)}</p>
          {days !== null && <p className={s.summaryMuted}>{formatMessage(messages.inspSummaryDays, { count: days })}</p>}
        </div>
        <div>
          <p className={s.summaryLabel}>{formatMessage(messages.inspSummaryRenter)}</p>
          <div className={s.partyRow}>
            {guestData && guestData.picture && <img className={s.avatar} src={`${photosShow(profilePhotouploadDir)}small_${guestData.picture}`} alt="" />}
            <p className={s.summaryValue}>{guestData ? guestData.firstName : '-'}</p>
          </div>
        </div>
        <div>
          <p className={s.summaryLabel}>{formatMessage(messages.inspSummaryOwner)}</p>
          <div className={s.partyRow}>
            {hostData && hostData.picture && <img className={s.avatar} src={`${photosShow(profilePhotouploadDir)}small_${hostData.picture}`} alt="" />}
            <p className={s.summaryValue}>{hostData ? hostData.firstName : '-'}</p>
          </div>
        </div>
      </div>
    </section>
  );
}

ReservationSummaryCard.propTypes = {
  reservation: PropTypes.object,
  dynamicTitle: PropTypes.any
};

export default injectIntl(withStyles(s)(ReservationSummaryCard));
